/** Eagle Eye subscription event types — extend this list as new analytics are onboarded. */
export type EagleEyeEventTypeOption = {
    eventTypeId: string;
    label: string;
    description?: string;
};

export const EAGLE_EYE_EVENT_TYPE_OPTIONS: EagleEyeEventTypeOption[] = [
    {
        eventTypeId: 'een.lprPlateReadEvent.v1',
        label: 'Vehicle Detection (LPR)',
        description: 'License plate read events from connected cameras.',
    },
    {
        eventTypeId: 'een.eevaQueryEvent.v1',
        label: 'EEVA Vision Analytics (Sticker / Tow)',
        description: 'Shared EEVA Query events for sticker, tow, and other EEVA analytics on a camera.',
    },
    {
        eventTypeId: 'een.device.labelDetectionEvent.v1',
        label: 'Label Detection',
        description: 'Legacy label detection analytics events.',
    },
    {
        eventTypeId: 'een.motionDetectionEvent.v1',
        label: 'Motion Detection',
        description: 'Motion detection events from connected cameras.',
    },
];

export function eagleEyeEventTypeLabel(eventTypeId: string): string {
    const match = EAGLE_EYE_EVENT_TYPE_OPTIONS.find((option) => option.eventTypeId === eventTypeId);
    return match?.label || eventTypeId;
}

export function formatEventTypeList(eventTypes: string[] | null | undefined): string {
    if (!eventTypes?.length) {
        return '—';
    }
    return eventTypes.map((eventType) => eagleEyeEventTypeLabel(eventType)).join(', ');
}
